import bookReducer from './';

export default bookReducer;
